import * as yup from 'yup';

yup.setLocale({
	mixed: {
		required: 'error.required', // Translation key goes here
		notType: 'error.required',
	},
	string: {
		required: 'error.required',
	},
	number: {
		required: 'error.required',
	},
	boolean: {
		isValue: 'error.required',
	},
	array: {
		required: 'error.minOneSelected',
	},
});

export const RiskEvaluationSchema = yup.object().shape({
	answers: yup.array(),
});
